var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMatches(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/like-shapes"
  }, /*#__PURE__*/React.createElement("g", {
    id: "like-shapes"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.5609 10.74L20.2009 9.16C19.9409 8.86 19.7309 8.3 19.7309 7.9V6.2C19.7309 5.14 18.8609 4.27 17.8009 4.27H16.1009C15.7109 4.27 15.1409 4.06 14.8409 3.8L13.2609 2.44C12.5709 1.85 11.4409 1.85 10.7409 2.44L9.17086 3.81C8.87086 4.06 8.30086 4.27 7.91086 4.27H6.18086C5.12086 4.27 4.25086 5.14 4.25086 6.2V7.91C4.25086 8.3 4.04086 8.86 3.79086 9.16L2.44086 10.75C1.86086 11.44 1.86086 12.56 2.44086 13.25L3.79086 14.84C4.04086 15.14 4.25086 15.7 4.25086 16.09V17.8C4.25086 18.86 5.12086 19.73 6.18086 19.73H7.91086C8.30086 19.73 8.87086 19.94 9.17086 20.2L10.7509 21.56C11.4409 22.15 12.5709 22.15 13.2709 21.56L14.8509 20.2C15.1509 19.94 15.7109 19.73 16.1109 19.73H17.8109C18.8709 19.73 19.7409 18.86 19.7409 17.8V16.1C19.7409 15.71 19.9509 15.14 20.2109 14.84L21.5709 13.26C22.1509 12.57 22.1509 11.43 21.5609 10.74ZM16.6809 12L15.5109 15.56C15.3609 16.15 14.7309 16.63 14.0909 16.63H12.2409C11.9209 16.63 11.4709 16.52 11.2709 16.32L9.80086 15.17C9.77086 15.81 9.48086 16.08 8.77086 16.08H8.29086C7.55086 16.08 7.25086 15.79 7.25086 15.09V10.31C7.25086 9.61 7.55086 9.32 8.29086 9.32H8.78086C9.52086 9.32 9.82086 9.61 9.82086 10.31V10.67L11.7609 7.79C11.9609 7.48 12.4709 7.26 12.9009 7.43C13.3709 7.59 13.6709 8.11 13.5709 8.57L13.3309 10.13C13.3109 10.27 13.3409 10.4 13.4309 10.5C13.5109 10.59 13.6309 10.65 13.7609 10.65H15.7109C16.0909 10.65 16.4109 10.8 16.6009 11.07C16.7709 11.33 16.8009 11.66 16.6809 12Z",
    fill: "#A9B7BB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatches);
export default __webpack_public_path__ + "static/media/matches.858652d0d609fe6e52e45a881c701113.svg";
export { ForwardRef as ReactComponent };